<template>
  <div class="ai-chat-nav-section">
    <nav-item
      class="_new-chat"
      :title="$t('aiChat.newChat')"
      icon="chat-plus"
      hover-color="beige"
      :active="chatId === null"
      @click="open(null)"
    />
    <m-endless-scroll-list @visible="loadMore">
      <div
        v-for="group in groups"
        :key="group.key"
        class="_group"
      >
        <nav-sub-heading :title="$t(`aiChat.groups.${group.key}`)" />
        <ai-chat-nav-chat
          v-for="chat in group.chats"
          :key="chat.uid"
          :chat="chat"
          :active="chat.uid === chatId"
          @select="open(chat.uid)"
        />
      </div>
    </m-endless-scroll-list>
    <div
      v-if="loading"
      class="_loading"
    >
      <m-spinner size="xs" />
    </div>
  </div>
</template>

<script setup>
import AiChatNavChat from '@/components/ai-chat/AiChatNavChat.vue';
import NavItem from '@/components/navigation/NavItem.vue';
import NavSubHeading from '@/components/navigation/NavSubHeading.vue';
import useAiChatList from '@/composables/ai-chat/ai-chat-list';
import { chatIdFromParam, fullScreenRoute } from '@/lib/ai-chat-route';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const { groups, loading, loadMore } = useAiChatList();

const chatId = computed(() => chatIdFromParam(route.params.chatId));

const open = (uid) => router.replace(fullScreenRoute(uid));
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .ai-chat-nav-section {
    ._group {
      margin-top: 1.2rem;
    }

    ._loading {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 4rem;
    }
  }
</style>
